import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServiceRequestByItemId } from 'src/store/actions/serviceRequests';
import { selectServiceRequests } from 'src/store/selectors/serviceRequests';
import ServiceRequestsTable from '../../components/ServiceRequestsTable/ServiceRequestsTable_legacy';
import { clearSearch } from 'src/store/actions/search';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import Loader from '../../components/Loader';
import { selectLoader } from 'src/store/selectors/loader';
import { PATHS } from 'src/common/constants';
import { fetchCatalogItemServiceRequestCSVExportDownloadList } from 'src/store/actions/csvExport';

interface ItemServiceRequestProps {
  item: any;
}

const ItemServiceRequest = ({ item }: ItemServiceRequestProps) => {
  const [searchString, setSearchString] = useState<string>('');

  const paginationCount = useSelector(
    (state: any) => state.paginationCount.count
  );
  const serviceRequests = useSelector(selectServiceRequests);
  const user = useSelector(selectAuthenticatedUser);
  const loader = useSelector(selectLoader);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchServiceRequestByItemId(
        item.id,
        user.id,
        user.roles[0].role.name,
        1,
        ''
      )
    );

    dispatch(clearSearch());
  }, [dispatch, item.id, user.id, user.roles]);

  const loadMoreServiceRequest = async () => {
    dispatch(
      fetchServiceRequestByItemId(
        item.id,
        user.id,
        user.roles[0].role.name,
        paginationCount + 1,
        searchString
      )
    );
  };

  const search = async (text: string) => {
    setSearchString(text);
    dispatch(
      fetchServiceRequestByItemId(
        item.id,
        user.id,
        user.roles[0].role.name,
        1,
        text,
        true
      )
    );
  };

  const downloadCSV = () => {
    dispatch(
      fetchCatalogItemServiceRequestCSVExportDownloadList(
        item.id,
        user.id,
        user.roles[0].role.name,
        searchString
      )
    );
  };

  return loader ? (
    <Loader />
  ) : (
    <ServiceRequestsTable
      download={downloadCSV}
      serviceRequests={serviceRequests}
      onSearch={(e: React.ChangeEvent<HTMLInputElement>) =>
        search(e.target.value.trim())
      }
      itemView={true}
      loadServiceRequest={loadMoreServiceRequest}
      from="Item"
      navigateTo={PATHS.ITEMS_VIEW.replace(':id', item.id)}
    />
  );
};

export default ItemServiceRequest;
